import React, { useEffect } from 'react';
import { toast } from 'sonner';
import { ShoppingCartIcon } from 'lucide-react';
const BUYERS = [{
  name: 'Marco',
  city: 'Roma'
}, {
  name: 'Giulia',
  city: 'Milano'
}, {
  name: 'Alessandro',
  city: 'Napoli'
}, {
  name: 'Francesca',
  city: 'Torino'
}, {
  name: 'Luca',
  city: 'Firenze'
}, {
  name: 'Chiara',
  city: 'Bologna'
}, {
  name: 'Giuseppe',
  city: 'Palermo'
}, {
  name: 'Sofia',
  city: 'Venezia'
}, {
  name: 'Matteo',
  city: 'Genova'
}, {
  name: 'Elena',
  city: 'Verona'
}, {
  name: 'Andrea',
  city: 'Bari'
}, {
  name: 'Valentina',
  city: 'Catania'
}];
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/pb2oZ2RUzyQBkYMGwuGsQQ/Tomo_1.png';
export function PurchasePopup() {
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const showRandomToast = () => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      toast.custom(() => <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-3 flex items-center gap-3 max-w-sm w-full" data-id="element-166">
            <img src={PRODUCT_IMG} alt="Mega-Pack" className="w-12 h-12 rounded-lg object-cover flex-shrink-0" data-id="element-167" />
            <div className="flex-1 min-w-0" data-id="element-168">
              <p className="text-sm text-gray-800 font-medium" data-id="element-169">
                <span className="font-bold" data-id="element-170">{randomBuyer.name}</span> da{' '}
                {randomBuyer.city}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-171">
                Ha appena acquistato questo prodotto
              </p>
            </div>
            <ShoppingCartIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-172" />
          </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      timeoutId = setTimeout(showRandomToast, nextDelay);
    };
    const initialTimer = setTimeout(showRandomToast, 10000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(timeoutId);
    };
  }, []);
  return null;
}